import { observable, action } from 'mobx'
import { get, post } from 'axios'
import moment from 'moment'
import { pick, omitBy, isNull } from 'lodash'
import store from 'store'
import { get as ENV } from 'react-global-configuration'

import Store from  './_store'

if (typeof window !== 'undefined') {
  window.gtag = window.gtag || (() => {})
}


class TripLog extends Store {
  DATE_FORMAT = 'DD MMM, YYYY'

  @observable isSuccess:boolean = true
  @observable from = null
  @observable to = null
  @observable notes = null
  @observable ticket = null
  @observable when = null
  @observable passport = null
  @observable airline = null
  @observable askedForOnwardTicket = null
  @observable FFTpresented = null

  @action submit = async ({silent}={silent:false}) => {
    this.loading = true
    this.success = null
    let data = pick(this, ['isSuccess', 'from', 'to', 'notes', 'ticket', 'passport'])
    data = omitBy(data, isNull)
    try {
      const res = await post(`${ENV('apiDomain')}/triplog`, data)
      if (!silent) {
        this.success = true
      }
    } catch (err) {
      this.catchError(err)
    } finally {
      this.loading = false
    }
  }
}

export default new TripLog()



// WEBPACK FOOTER //
// ./src/stores/TripLog.js